/* SMT-V144-PRODUCT-PAGE-REFINEMENT */
(function () {
  'use strict';

  function normalizeText(value) {
    return String(value || '')
      .replace(/\u0131/g, 'i')
      .replace(/\u0130/g, 'I')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function groupForHeading(value) {
    var text = normalizeText(value);
    if (/paket|kutu|icerik/.test(text)) return 'package';
    if (/uyum|uygun|arac/.test(text)) return 'fit';
    if (/kumas|malzeme|deri|doku|dokuma/.test(text)) return 'material';
    if (/montaj|hava yast|airbag|guven/.test(text)) return 'safety';
    if (/koruma|ozellik|cep|uretim|yerli/.test(text)) return 'features';
    return '';
  }

  function labelForGroup(key) {
    var labels = {
      package: 'Paket \u0130\u00e7eri\u011fi',
      fit: 'Ara\u00e7 Uyumlulu\u011fu',
      material: 'Kuma\u015f ve Malzeme',
      safety: 'Montaj ve G\u00fcvenlik',
      features: '\u00dcr\u00fcn \u00d6zellikleri'
    };
    return labels[key] || '\u00dcr\u00fcn Detaylar\u0131';
  }

  function removeBrandKicker(root) {
    root.querySelectorAll('.smt-product-kicker, .product__text.caption-with-letter-spacing, .product__text.inline-richtext.caption-with-letter-spacing').forEach(function (element) {
      element.remove();
    });
  }

  function removeDuplicateProductContent(root) {
    root.querySelectorAll('.product__title > a').forEach(function (element) {
      element.remove();
    });

    var seenDescriptions = {};
    root.querySelectorAll('.product__description').forEach(function (element) {
      var key = normalizeText(element.textContent);
      if (!key) return;
      if (seenDescriptions[key]) {
        element.remove();
        return;
      }
      seenDescriptions[key] = true;
    });

    var gallery = root.querySelector('media-gallery');
    if (!gallery) return;
    var seenMedia = {};
    gallery.querySelectorAll('.product__media-item').forEach(function (item) {
      var image = item.querySelector('img');
      if (!image) return;
      var source = image.getAttribute('src') || image.currentSrc || image.src || '';
      var key = source.replace(/([?&])width=\d+/i, '$1width=normalized');
      if (seenMedia[key]) {
        item.remove();
        return;
      }
      seenMedia[key] = true;
    });
  }

  function cleanTaxText(root) {
    var tax = root.querySelector('.product__tax');
    if (!tax) return;

    Array.prototype.slice.call(tax.childNodes).forEach(function (node) {
      if (node.nodeType !== Node.TEXT_NODE) return;
      node.nodeValue = String(node.nodeValue || '').replace(/Vergiler\s+dahil\.\s*/gi, '');
    });
  }

  function removeShare(root) {
    root.querySelectorAll('share-button, .share-button, .product__view-details').forEach(function (element) {
      element.remove();
    });
  }

  function enhanceDescription(root) {
    var description = root.querySelector('.product__description');
    if (!description || description.dataset.smtV144Enhanced === 'true') return;

    var titleElement = root.querySelector('.product__title h1');
    var productTitle = normalizeText(titleElement ? titleElement.textContent : '');
    var children = Array.prototype.slice.call(description.children || []).filter(function (child) {
      var text = normalizeText(child.textContent);
      if (!text) return false;
      if (/ayni gun ucretsiz kargo/.test(text)) return false;
      if (productTitle && text === productTitle) return false;
      return true;
    });
    if (!children.length) return;

    var intro = [];
    var groupOrder = [];
    var groups = {};
    var activeGroup = '';

    children.forEach(function (child) {
      var headingElement = child.querySelector('strong, b');
      var detectedGroup = headingElement ? groupForHeading(headingElement.textContent) : '';

      if (detectedGroup) {
        activeGroup = detectedGroup;
        if (!groups[activeGroup]) {
          groups[activeGroup] = [];
          groupOrder.push(activeGroup);
        }
        groups[activeGroup].push(child.cloneNode(true));
      } else if (activeGroup && groups[activeGroup]) {
        groups[activeGroup].push(child.cloneNode(true));
      } else {
        intro.push(child.cloneNode(true));
      }
    });

    var shell = document.createElement('details');
    shell.className = 'smt-product-description-shell';

    var shellSummary = document.createElement('summary');
    shellSummary.className = 'smt-product-description-shell__summary';
    shellSummary.innerHTML = '<span>\u00dcr\u00fcn A\u00e7\u0131klamas\u0131</span><span class="smt-product-description-shell__state" aria-hidden="true"></span>';
    shell.appendChild(shellSummary);

    var shellContent = document.createElement('div');
    shellContent.className = 'smt-product-description-shell__content';

    if (intro.length) {
      var introBox = document.createElement('div');
      introBox.className = 'smt-product-intro';
      intro.forEach(function (node) { introBox.appendChild(node); });
      shellContent.appendChild(introBox);
    }

    if (groupOrder.length) {
      var accordion = document.createElement('div');
      accordion.className = 'smt-product-accordion';

      groupOrder.forEach(function (key) {
        var details = document.createElement('details');
        details.className = 'smt-product-detail';

        var summary = document.createElement('summary');
        summary.textContent = labelForGroup(key);

        var content = document.createElement('div');
        content.className = 'smt-product-detail__content';
        groups[key].forEach(function (node) { content.appendChild(node); });

        details.appendChild(summary);
        details.appendChild(content);
        details.addEventListener('toggle', function () {
          if (!details.open) return;
          accordion.querySelectorAll('.smt-product-detail[open]').forEach(function (other) {
            if (other !== details) other.open = false;
          });
        });
        accordion.appendChild(details);
      });

      shellContent.appendChild(accordion);
    } else {
      children.forEach(function (child) { shellContent.appendChild(child.cloneNode(true)); });
    }

    shell.appendChild(shellContent);
    description.innerHTML = '';
    description.appendChild(shell);
    description.dataset.smtV144Enhanced = 'true';
  }

  function enhanceGallery(root) {
    var gallery = root.querySelector('media-gallery');
    if (!gallery || gallery.dataset.smtV144Enhanced === 'true') return;

    var items = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-list > .product__media-item'));
    if (!items.length) return;

    gallery.classList.add('smt-gallery-enhanced');
    gallery.dataset.smtV144Enhanced = 'true';

    var currentIndex = Math.max(0, items.findIndex(function (item) {
      return item.classList.contains('is-active');
    }));

    var controls = document.createElement('div');
    controls.className = 'smt-gallery-controls';
    controls.innerHTML = [
      '<div class="smt-gallery-navigation">',
      '<button class="smt-gallery-arrow smt-gallery-arrow--previous" type="button" aria-label="\u00d6nceki g\u00f6rsel"><span aria-hidden="true">\u2039</span></button>',
      '<div class="smt-gallery-counter" aria-live="polite"><span class="smt-gallery-counter__current"></span><span aria-hidden="true"> / </span><span class="smt-gallery-counter__total"></span></div>',
      '<button class="smt-gallery-arrow smt-gallery-arrow--next" type="button" aria-label="Sonraki g\u00f6rsel"><span aria-hidden="true">\u203a</span></button>',
      '</div>',
      '<div class="smt-gallery-thumbnails" role="tablist" aria-label="\u00dcr\u00fcn g\u00f6rselleri"></div>'
    ].join('');

    var thumbnailStrip = controls.querySelector('.smt-gallery-thumbnails');
    items.forEach(function (item, index) {
      var image = item.querySelector('img');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'smt-gallery-thumbnail';
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-label', (index + 1) + '. g\u00f6rseli g\u00f6ster');
      if (image) {
        var thumb = document.createElement('img');
        var sourceUrl = image.getAttribute('src') || image.currentSrc || image.src;
        if (/([?&])width=\d+/i.test(sourceUrl)) {
          sourceUrl = sourceUrl.replace(/([?&])width=\d+/i, '$1width=160');
        } else {
          sourceUrl += (sourceUrl.indexOf('?') >= 0 ? '&' : '?') + 'width=160';
        }
        thumb.src = sourceUrl;
        thumb.alt = '';
        thumb.loading = 'lazy';
        button.appendChild(thumb);
      } else {
        button.textContent = String(index + 1);
      }
      button.addEventListener('click', function () { show(index, true); });
      thumbnailStrip.appendChild(button);
    });

    var nativeControls = gallery.querySelector('.slider-buttons');
    if (nativeControls && nativeControls.parentNode) {
      nativeControls.parentNode.insertBefore(controls, nativeControls.nextSibling);
    } else {
      gallery.appendChild(controls);
    }

    var currentCounter = controls.querySelector('.smt-gallery-counter__current');
    var totalCounter = controls.querySelector('.smt-gallery-counter__total');
    var thumbnails = Array.prototype.slice.call(controls.querySelectorAll('.smt-gallery-thumbnail'));
    totalCounter.textContent = String(items.length);

    function show(index, moveFocus) {
      currentIndex = (index + items.length) % items.length;
      items.forEach(function (item, itemIndex) {
        var isCurrent = itemIndex === currentIndex;
        item.classList.toggle('smt-media-current', isCurrent);
        item.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
        if ('inert' in item) item.inert = !isCurrent;
        var image = item.querySelector('img');
        if (isCurrent && image) image.loading = 'eager';
      });
      thumbnails.forEach(function (button, buttonIndex) {
        var isSelected = buttonIndex === currentIndex;
        button.classList.toggle('is-current', isSelected);
        button.setAttribute('aria-selected', isSelected ? 'true' : 'false');
        button.tabIndex = isSelected ? 0 : -1;
      });
      currentCounter.textContent = String(currentIndex + 1);
      if (thumbnails[currentIndex]) {
        thumbnails[currentIndex].scrollIntoView({ block: 'nearest', inline: 'nearest' });
        if (moveFocus) gallery.focus({ preventScroll: true });
      }
    }

    controls.querySelector('.smt-gallery-arrow--previous').addEventListener('click', function () {
      show(currentIndex - 1, true);
    });
    controls.querySelector('.smt-gallery-arrow--next').addEventListener('click', function () {
      show(currentIndex + 1, true);
    });

    gallery.tabIndex = 0;
    gallery.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(currentIndex - 1, false);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(currentIndex + 1, false);
      }
    });

    var touchStartX = 0;
    gallery.addEventListener('touchstart', function (event) {
      if (event.touches && event.touches.length === 1) touchStartX = event.touches[0].clientX;
    }, { passive: true });
    gallery.addEventListener('touchend', function (event) {
      if (!event.changedTouches || event.changedTouches.length !== 1) return;
      var distance = event.changedTouches[0].clientX - touchStartX;
      if (Math.abs(distance) < 48) return;
      show(currentIndex + (distance < 0 ? 1 : -1), false);
    }, { passive: true });

    var lastNativeActiveIndex = currentIndex;
    var observer = new MutationObserver(function () {
      var activeIndex = items.findIndex(function (item) { return item.classList.contains('is-active'); });
      if (activeIndex >= 0 && activeIndex !== lastNativeActiveIndex) {
        lastNativeActiveIndex = activeIndex;
        show(activeIndex, false);
      }
    });
    items.forEach(function (item) {
      observer.observe(item, { attributes: true, attributeFilter: ['class'] });
    });

    show(currentIndex, false);
  }

  function localizeRecommendations() {
    var candidates = document.querySelectorAll('product-recommendations h2, .related-products h2');
    candidates.forEach(function (heading) {
      if (normalizeText(heading.textContent) === 'you may also like') {
        heading.textContent = 'Bunlar da ilginizi \u00e7ekebilir';
      }
    });
  }

  function initializeProductPage() {
    var rootElement = document.querySelector('[id^="MainProduct-"]');
    if (!rootElement) return;

    document.documentElement.classList.add('smt-product-page');
    removeBrandKicker(rootElement);
    removeDuplicateProductContent(rootElement);
    cleanTaxText(rootElement);
    removeShare(rootElement);
    enhanceDescription(rootElement);
    enhanceGallery(rootElement);
    localizeRecommendations();

    /* SMT-V9.2-RECOMMENDATION-OBSERVER-SCOPED-START */
    var recommendationRoot = document.querySelector('product-recommendations') ||
      document.querySelector('.related-products');
    if (recommendationRoot && typeof MutationObserver === 'function') {
      var recommendationFrame = 0;
      var recommendationObserver = new MutationObserver(function () {
        if (recommendationFrame) return;
        recommendationFrame = window.requestAnimationFrame(function () {
          recommendationFrame = 0;
          localizeRecommendations();
        });
      });
      recommendationObserver.observe(recommendationRoot, { childList: true, subtree: true });
      window.setTimeout(function () {
        recommendationObserver.disconnect();
        if (recommendationFrame) window.cancelAnimationFrame(recommendationFrame);
      }, 8000);
    }
    /* SMT-V9.2-RECOMMENDATION-OBSERVER-SCOPED-END */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductPage, { once: true });
  } else {
    initializeProductPage();
  }
})();

/* SMT-V145-PRODUCT-PAGE-FINAL-ALIGNMENT-START */
(function () {
  'use strict';

  if (window.SMT_V145_PRODUCT_ALIGNMENT_ACTIVE) return;
  window.SMT_V145_PRODUCT_ALIGNMENT_ACTIVE = true;

  var desktopQuery = window.matchMedia('(min-width: 990px)');
  var scheduled = 0;

  function synchronizeMainStage() {
    scheduled = 0;
    var gallery = document.querySelector('media-gallery.smt-gallery-enhanced');
    var panel = document.querySelector('[id^="MainProduct-"] .product__info-container');
    if (!gallery || !panel) return;

    if (!desktopQuery.matches) {
      gallery.style.removeProperty('--smt-v145-panel-height');
      return;
    }

    var description = panel.querySelector('.smt-product-description-shell');
    if (description && description.open) return;

    var height = Math.round(panel.getBoundingClientRect().height);
    if (height >= 420 && height <= 1400) {
      gallery.style.setProperty('--smt-v145-panel-height', height + 'px');
    }
  }

  function scheduleSynchronization() {
    if (scheduled) window.cancelAnimationFrame(scheduled);
    scheduled = window.requestAnimationFrame(synchronizeMainStage);
  }

  function initialize() {
    var gallery = document.querySelector('media-gallery.smt-gallery-enhanced');
    var panel = document.querySelector('[id^="MainProduct-"] .product__info-container');
    if (!gallery || !panel) {
      window.setTimeout(initialize, 120);
      return;
    }

    scheduleSynchronization();
    window.setTimeout(scheduleSynchronization, 350);
    window.setTimeout(scheduleSynchronization, 1000);
    window.addEventListener('resize', scheduleSynchronization, { passive: true });

    if (typeof ResizeObserver === 'function') {
      var observer = new ResizeObserver(function () {
        var description = panel.querySelector('.smt-product-description-shell');
        if (!description || !description.open) scheduleSynchronization();
      });
      observer.observe(panel);
    }

    var description = panel.querySelector('.smt-product-description-shell');
    if (description) {
      description.addEventListener('toggle', function () {
        if (!description.open) window.setTimeout(scheduleSynchronization, 30);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
/* SMT-V145-PRODUCT-PAGE-FINAL-ALIGNMENT-END */

/* SMT-V146-PRODUCT-PURCHASE-STACK-START */
(function () {
  'use strict';

  if (window.SMT_V146_PURCHASE_STACK_ACTIVE) return;
  window.SMT_V146_PURCHASE_STACK_ACTIVE = true;

  function insertImmediatelyAfter(reference, element) {
    if (!reference || !element || !reference.parentNode) return;
    reference.parentNode.insertBefore(element, reference.nextSibling);
  }

  function arrangePurchaseStack() {
    var root = document.querySelector('[id^="MainProduct-"]');
    if (!root) return false;

    var panel = root.querySelector('.product__info-container');
    var form = panel && (panel.querySelector('product-form.product-form') || panel.querySelector('.product-form'));
    var description = panel && panel.querySelector('.product__description');
    var quantity = panel && panel.querySelector('.product-form__quantity');
    if (!panel || !form || !quantity) return false;

    var purchaseLayout = panel.querySelector('.smt-product-purchase-layout');
    if (!purchaseLayout) {
      purchaseLayout = document.createElement('div');
      purchaseLayout.className = 'smt-product-purchase-layout';
      quantity.parentNode.insertBefore(purchaseLayout, quantity);
      purchaseLayout.appendChild(quantity);
      purchaseLayout.appendChild(form);
    }

    if (description) insertImmediatelyAfter(purchaseLayout, description);
    panel.classList.add('smt-v146-purchase-stack-ready');

    window.dispatchEvent(new Event('resize'));
    return true;
  }

  function initialize() {
    if (arrangePurchaseStack()) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (arrangePurchaseStack() || attempts >= 30) {
        window.clearInterval(timer);
      }
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
/* SMT-V146-PRODUCT-PURCHASE-STACK-END */

/* SMT-V148-RELATED-HEADING-PAGE-CLOSING-START */
(function () {
  'use strict';

  if (window.SMT_V148_PAGE_CLOSING_ACTIVE) return;
  window.SMT_V148_PAGE_CLOSING_ACTIVE = true;

  var directionsUrl = 'https://google.com/maps/place/ULUDA%C4%9E+OTO+KILIF+-+SINCE+1984/@37.7608798,29.0809008,15z/data=!4m6!3m5!1s0x14c73fb9f0254b27:0x9ecb44a8d23a676d!8m2!3d37.7852949!4d29.0787579!16s%2Fg%2F11bx9mzn_y';

  function buildClosingSection() {
    if (document.querySelector('.smt-product-closing')) return true;

    var recommendations = document.querySelector('product-recommendations') || document.querySelector('.related-products');
    if (!recommendations || !recommendations.parentNode) return false;

    var seoIntent = document.querySelector('.smt-seo-v11-intent');
    var insertionTarget = seoIntent || recommendations.closest('.shopify-section') || recommendations;
    if (!insertionTarget.parentNode) return false;

    var titleElement = document.querySelector('[id^="MainProduct-"] .product__title h1');
    var productTitle = titleElement ? String(titleElement.textContent || '').replace(/\s+/g, ' ').trim() : '\u0130nceledi\u011Fim \u00FCr\u00FCn';
    var whatsappText = 'Merhaba, ' + productTitle + ' \u00FCr\u00FCn\u00FCn arac\u0131ma uyumlulu\u011Fu ve \u00FCr\u00FCn detaylar\u0131 hakk\u0131nda bilgi almak istiyorum.';
    var whatsappUrl = 'https://wa.me/905367408950?text=' + encodeURIComponent(whatsappText);
    var year = new Date().getFullYear();
    var logoUrl = typeof window.SMT_V144_HEADER_LOGO === 'string' ? window.SMT_V144_HEADER_LOGO : '';

    var section = document.createElement('section');
    section.className = 'smt-product-closing';
    section.setAttribute('aria-labelledby', 'smt-product-closing-title');

    var logoMarkup = logoUrl
      ? '<img class="smt-product-closing__logo" src="' + logoUrl + '" alt="SMT Oto Tekstil ve Aksesuar" loading="lazy">'
      : '';

    section.innerHTML = [
      '<div class="smt-product-closing__inner">',
        '<div class="smt-product-closing__support">',
          '<div class="smt-product-closing__copy">',
            '<p class="smt-product-closing__kicker">\u00DCr\u00FCn se\u00E7imi \u00B7 T\u00FCrkiye geneli kargo</p>',
            '<h2 class="smt-product-closing__title" id="smt-product-closing-title">Arac\u0131n\u0131za uygun \u00FCr\u00FCn\u00FC kolayca se\u00E7in.</h2>',
            '<p class="smt-product-closing__text">\u00DCr\u00FCn a\u00E7\u0131klamas\u0131ndaki uyumluluk, kuma\u015F ve \u00F6l\u00E7\u00FC bilgilerini inceleyin. T\u00FCrkiye\u2019nin her yerine g\u00FCvenli kargo ile g\u00F6nderim yap\u0131yoruz.</p>',
          '</div>',
          '<div class="smt-product-closing__actions">',
            '<a class="smt-product-closing__action smt-product-closing__action--primary" href="' + whatsappUrl + '" target="_blank" rel="noopener">Uyumluluk deste\u011Fi al</a>',
            '<a class="smt-product-closing__action smt-product-closing__action--secondary" href="' + directionsUrl + '" target="_blank" rel="noopener">Ma\u011Fazada incele</a>',
          '</div>',
        '</div>',
        '<div class="smt-product-closing__brand">',
          '<div class="smt-product-closing__identity">',
            logoMarkup,
            '<div class="smt-product-closing__identity-text"><strong>SMT OTO TEKST\u0130L VE AKSESUAR</strong><span>1984\u2019ten beri Denizli\u2019de</span></div>',
          '</div>',
          '<p class="smt-product-closing__copyright">\u00A9 ' + year + ' SMT Oto Tekstil ve Aksesuar. T\u00FCm haklar\u0131 sakl\u0131d\u0131r.</p>',
        '</div>',
      '</div>'
    ].join('');

    insertionTarget.parentNode.insertBefore(section, insertionTarget.nextSibling);
    return true;
  }

  function initialize() {
    if (buildClosingSection()) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (buildClosingSection() || attempts >= 80) {
        window.clearInterval(timer);
      }
    }, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
/* SMT-V148-RELATED-HEADING-PAGE-CLOSING-END */
/* SMT-V175-VARIANT-GALLERY-RESYNC-20260910 */
/* Dawn varyant degisiminden sonra aktif slaytta custom gorunurluk sinifini yeniden kur. */
(() => {
  'use strict';

  const syncVariantGallery = () => {
    document.querySelectorAll('html.smt-product-page media-gallery.smt-gallery-enhanced').forEach((gallery) => {
      const active = gallery.querySelector('.product__media-item.is-active');
      if (!active) return;

      const current = gallery.querySelector('.product__media-item.smt-media-current');
      if (current && current !== active) current.classList.remove('smt-media-current');
      if (!active.classList.contains('smt-media-current')) active.classList.add('smt-media-current');
    });
  };

  const scheduleVariantGallerySync = () => {
    window.requestAnimationFrame(syncVariantGallery);
    window.setTimeout(syncVariantGallery, 100);
    window.setTimeout(syncVariantGallery, 450);
  };

  document.addEventListener('change', (event) => {
    const target = event.target;
    if (target && target.closest && target.closest('variant-selects, input[name^="options"], select[name^="options"]')) {
      scheduleVariantGallerySync();
    }
  }, true);

  document.addEventListener('shopify:section:load', scheduleVariantGallerySync);

  const boot = () => {
    syncVariantGallery();
    const gallery = document.querySelector('html.smt-product-page media-gallery.smt-gallery-enhanced');
    if (gallery && window.MutationObserver) {
      new MutationObserver(scheduleVariantGallerySync).observe(gallery, {
        childList: true,
        subtree: true
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
